import React, {CSSProperties, useMemo} from 'react';
import cx from 'classnames';
import {ThumbnailProps} from './MediaGalleryThumbnailFactory';
import ThumbnailBase from './ThumbnailBase';
import {calcRotation} from '../../../Utils/Asset';
import {SelectionMode} from '../MediaGallery';
import {ThemeName, getTheme} from '@taopix/taopix-design-system';

const ThumbnailSquare = ({
  image,
  openDetailsDialog,
  used,
  onSelectPicture,
  selectableImages,
  onDragStart,
  onDragEnd,
  onTouchStart,
  onTouchEnd,
  onDeleteAsset,
  selected,
  localeString,
  currencyCode,
  expired,
  showDeleteButton = false,
  showPricing,
  showUsage,
  showLabel = false,
  selectionAppearance,
  disabled,
  columns,
  overlayDisplayMode,
  maxSelectionReached = false,
  selectionMode = SelectionMode.Multi,
  onKeyDown,
}: ThumbnailProps) => {
  // if the image is not processed, ignore rotation
  const rotation = useMemo(() => {
    return calcRotation(image);
  }, [image]);

  const rotatedStyles = useMemo(() => {
    return {
      position: 'absolute',
      transform: `rotate(${rotation}deg)`,
    };
  }, [rotation]) as CSSProperties;

  const containerClasses = [
    'group/thumbnail',
    'flex',
    'h-full',
    'relative',
    'self-start',
    'overflow-hidden',
    'before:block before:pt-[100%]',
    getTheme(ThemeName.Container, true, false, false),
  ];

  return (
    <li className={cx(containerClasses)}>
      <ThumbnailBase
        currencyCode={currencyCode}
        disabled={disabled}
        expired={expired}
        image={image}
        imageClasses={
          'absolute object-cover min-h-full min-w-full m-auto left-0 right-0 top-0 bottom-0 '
        }
        imageCSS={rotatedStyles}
        localeString={localeString}
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        onSelectPicture={onSelectPicture}
        onKeyDown={onKeyDown}
        onTouchEnd={onTouchEnd}
        onTouchStart={onTouchStart}
        openDetailsDialog={openDetailsDialog}
        selectionAppearance={selectionAppearance}
        selectableImages={selectableImages}
        selected={selected}
        showDeleteButton={showDeleteButton}
        showPricing={showPricing}
        showUsage={showUsage}
        showLabel={showLabel}
        used={used}
        overlayDisplayMode={overlayDisplayMode}
        onDeleteAsset={onDeleteAsset}
        maxSelectionReached={maxSelectionReached}
        selectionMode={selectionMode}
        thumbnailLayout="square-tiles"
      />
    </li>
  );
};

export default ThumbnailSquare;
